export enum MatchFilters {
	All = 'all',
	Live = 'live',
	Finished = 'finished',
	Scheduled = 'scheduled',
}